
@if (store) {
  <div
    class="p-2 flex flex-col rounded-xl border {{ !selected? colorscheme: '' }}"
     [ngClass]="{
     'border-e-dark-green text-e-dark-green': !selected,
     'border-e-dark-green bg-e-dark-green text-white': selected,
     'border-e-light-green bg-e-light-green text-e-dark-green': deliveryday?.ismoved && !selected
     }">
    <div class="flex flex-row justify-between">
      <div class="flex flex-col">
        <span class="font-bold">{{store?.name}}</span>
        <span class="block">{{store?.address}}</span>
        <span class="block">{{store?.postalcode}} {{store?.city}}</span>
      </div>
      <div class="text-end">
        <strong><small class="">{{store?.calculatedDistance}}</small></strong>
      </div>
    </div>
    @if (deliveryday) {
      <small class="">
        @if (deliveryday?.ismoved) {
          <i class="bi bi-arrow-bar-right me-1"></i>
        }
        <i class="bi bi-clock me-1"></i>
        <span class="text-lowercase">{{'subscription.pickup_possible_between' | translate: {day:( alternatedeliverydate? alternatedeliverydate:  deliveryday?.date) | date: 'EEEE'} }}</span>
        @if (deliveryday) {
          <span class="ms-1">{{deliveryday?.postalCodeWeekDayTimeFrames[0].timefrom.substring(0, 5)}} - {{deliveryday?.postalCodeWeekDayTimeFrames[0].timeto.substring(0, 5)}} </span>
        }
      </small>
    }
    @if (timeframe) {
      <small>
        <i class="bi bi-clock me-1"></i>
        <span class="text-lowercase">{{'subscription.pickup_possible_between' | translate: {day: 'weekday.' + timeframe?.weekday | translate} }}</span>
        <span class="ms-1"> {{timeframe.timefrom.substring(0, 5)}} - {{timeframe.timeto.substring(0, 5)}} </span>
      </small>
    }
  </div>
}
